@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@labelMargin: 7px;
@pipeHeightModifier: 2 * @labelMargin;

.button-container {
  display: flex;
}

.button-styles {
  background-clip: padding-box;
  border-right: 1px solid transparent;
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  width: 100%;

  &:disabled {
    border-right: 1px solid var(--gray-8D9196);
  }
}

.drop-down-menu-button {
  border-radius: 0 3px 3px 0;
  padding: 0;
}

.dropdown-menu {
  max-width: none;
}

.button-label {
  display: flex;
}
